"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplenishmentWorkflowTaskType = void 0;
exports.ReplenishmentWorkflowTaskType = {
    PALLET_BUILDING: "PALLET_BUILDING",
    EACHES_PACKAGING: "EACHES_PACKAGING",
    EACHES_LABEL_DOWNLOAD: "EACHES_LABEL_DOWNLOAD",
    EACHES_PALLET_BUILDING: "EACHES_PALLET_BUILDING",
    EACHES_VAS: "EACHES_VAS",
    MARK_AS_SHIPPED: "MARK_AS_SHIPPED",
    ROUTING_REPORT_UPLOAD: "ROUTING_REPORT_UPLOAD",
};
//# sourceMappingURL=replenishment-workflow-task-type.js.map